<template>
  <div>
    <v-text-field
        :disabled="disabled"
        :loading="loadingSlug"
        persistent-hint
        :hint="slug ? `Tu perfil estará disponible en <b class='primary--text'>${url}</b>` : 'Escribe algo para obtener tu link'"
        color="primary"
        fillled
        :error-messages="required && !slug ? ['Este campo es requerido'] : ''"
        clearable
        :required="required"
        v-model="name"
        prepend-inner-icon="fa-link"
        :append-icon="shareBtn ? 'fas fa-share-alt-square' : ''"
        @click:append="$refs.copier.show()"
        placeholder="Ej. El Super Especialista"
        :label="label">
        <template v-slot:message="{message, key}">
          <span v-html="message"></span>
        </template>
    </v-text-field>
    <link-share :url="url" ref="copier" />
  </div>
</template>

<script>
import {debounce} from "@/utils/Common";
import {ApiUtils} from "@/utils/ApiUtils";
import LinkShare from "@/components/common/LinkShare";

export default {
  name: "SlugPicker",
  components: {LinkShare},
  props:{
    shareBtn:{
      type: Boolean,
      default: false
    },
    required:{
      type: Boolean,
      default: false
    },
    label:{
      type: String,
      default: 'Escoge un alias'
    },
    disabled:{
      type: Boolean,
      default: false
    },
    defaultName: {
      type: String
    },
    defaultSlug: {
      type: String
    }
  },
  data(){
    return {
      name: '',
      slug: '',
      avoidSlugQuery: false,
      loadingSlug: false,
    }
  },
  mounted(){},
  computed:{
    domain(){
      return process.env.VUE_APP_PUBLIC_PROFILE_DOMAIN || ''
    },
    url(){
      const vm = this
      return `${vm.domain}/${vm.slug}`
    }
  },
  methods:{
    setDefaults(){
      const vm = this
      if(vm.defaultSlug){
        vm.avoidSlugQuery = true
        vm.slug = vm.defaultSlug
      }

      vm.$nextTick(function(){
        if(vm.defaultName){
          vm.name = vm.defaultName
          setTimeout(function(){
            vm.avoidSlugQuery = false
          }, 1500)
        }
      })

    },
    async getSlug(){
      var vm = this
      if(vm.loadingSlug) return
      if(!vm.name) return vm.slug = ''
      if(vm.avoidSlugQuery) return
      vm.loadingSlug = true
      const response = await ApiUtils.makeGet(`provider/slug/${vm.name}`)
      vm.loadingSlug = false

      if(response.ok){
        const json = await response.json()
        vm.slug = json.result.slug
      }

    },
    debounceSlug: debounce(function(){
      this.getSlug()
    }, 500)

  },
  watch: {
    name(val){
      this.debounceSlug()
      if(this.avoidSlugQuery) return
      this.$emit('change:name', val)
    },
    slug(val){
      if(this.avoidSlugQuery) return
      this.$emit('change:slug', val)
    }
  }
}
</script>

<style scoped>

</style>
